import { Tooltip } from 'ui/tooltip';
import { Link } from 'react-router-dom';
import { displayDate, getFromNow, DATE_FORMAT_FULL_WITH_TIME } from 'utils/date';
import { Cell, StyledUL } from './ReportsTable.styled';

export const BASE_COLUMNS = [
  {
    value: 'id',
    name: 'ID',
    RowCell: ({ row }) => (
      <Cell data-test="reports-table-id-cell">
        <Link to={`/reports/${row.id}`}>{row.id}</Link>
      </Cell>
    ),
  },
  {
    value: 'name',
    name: 'Name',
    RowCell: ({ row }) => (
      <Cell>
        <Link to={`/reports/${row.id}`}>{row.name}</Link>
      </Cell>
    ),
  },
  {
    value: 'createdAt',
    name: 'Created',
    RowCell: ({ row }) => (
      <Cell>
        <Tooltip
          isUnderlined
          tooltipContent={displayDate(row.createdAt, DATE_FORMAT_FULL_WITH_TIME)}
        >
          {getFromNow(row.createdAt)}
        </Tooltip>
      </Cell>
    ),
  },
  {
    value: 'updatedAt',
    name: 'Updated',
    RowCell: ({ row }) => (
      <Cell>
        <Tooltip
          isUnderlined
          tooltipContent={displayDate(row.updatedAt, DATE_FORMAT_FULL_WITH_TIME)}
        >
          {getFromNow(row.updatedAt)}
        </Tooltip>
      </Cell>
    ),
  },
  {
    value: 'creatorUserId',
    name: 'Created By',
    RowCell: ({ row }) => <Cell>{row.creatorUserId}</Cell>,
  },
  {
    value: 'rangeStart',
    name: 'Start',
    RowCell: ({ row }) => <Cell>{displayDate(row.rangeStart, DATE_FORMAT_FULL_WITH_TIME)}</Cell>,
  },
  {
    value: 'rangeEnd',
    name: 'End',
    RowCell: ({ row }) => <Cell>{displayDate(row.rangeEnd, DATE_FORMAT_FULL_WITH_TIME)}</Cell>,
  },
  {
    value: 'selectedMetrics',
    name: 'Metrics',
    sortable: false,
    RowCell: ({ row }) => (
      <Cell>
        <Tooltip
          isUnderlined
          tooltipContent={
            <StyledUL>
              {row.selectedMetrics?.map(({ name }) => (
                <li key={name}>{name}</li>
              ))}
            </StyledUL>
          }
        >
          {row.selectedMetrics?.length}
        </Tooltip>
      </Cell>
    ),
  },
];
